import { ItemRestraints } from '@core/shared/restraints';
/**
 * use this Restraints subtype for easier checking against info provided by User-based session
 */
export class UserBasedItemRestraints extends ItemRestraints {
  get access() {
    try {
      const tmp = this.accessProvider.get();
      return tmp;
    } catch (err) {
      throw new Error('UserBasedItemRestraints: Tried to get reference to AccessService outside of a request scope/context. Likely you are executing system-level operations which the Restraints class does not yet expect and check.');
    }
  }
  constructor(accessProvider, executorProvider) {
    super(accessProvider, executorProvider);
    this.accessProvider = accessProvider;
    this.executorProvider = executorProvider;
  }
  // ########  HELPER METHODS  ################################################################
  userManagesCompany(companyId) {
    const managedCompany = this.access.getAccessData('managedCompany', null, 'throw');
    return managedCompany?.id === companyId;
  }
  userBelongsToCompany(companyId) {
    const company = this.access.getAccessData('company', null, 'throw');
    return company?.id === companyId;
  }
}
export class UserBasedAdminOnlyItemRestraints extends UserBasedItemRestraints {
  canCreateItem(item) {
    return this.isExecutedBySystem() || this.requireRole('ADMINISTRATOR');
  }
  canViewItem(item) {
    return this.isExecutedBySystem() || this.requireRole('ADMINISTRATOR');
  }
  canToggleItem(item) {
    return this.isExecutedBySystem() || this.requireRole('ADMINISTRATOR');
  }
  canUpdateItem(item, oldItem) {
    return this.isExecutedBySystem() || this.requireRole('ADMINISTRATOR');
  }
  canRemoveItem(item) {
    return this.isExecutedBySystem() || this.requireRole('ADMINISTRATOR');
  }
}
export class UserBasedReadonlyItemRestraints extends UserBasedItemRestraints {
  canToggleItem(item) {
    return 'Not toggleable';
  }
  canUpdateItem(item, oldItem) {
    return 'Not updateable';
  }
  canRemoveItem(item) {
    return 'Not removable';
  }
}